import { Component, Input, OnChanges } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-employee-vacation-pay-method-form',
    templateUrl: './employee-vacation-pay-method.form.template.html',
})
export class EmployeeVacationPayMethodForm extends BaseForm implements OnChanges {
    @Input() employee: Employee;
    @Input() pendingPayrollExists = false;
    employeeVacationPayMethod: string = null;

    constructor() {
        super();
    }

    ngOnChanges(): void {
        if (!this.employee) {
            return;
        }
        this.employee.vacationPayMethod === null
            ? (this.employeeVacationPayMethod = 'vacation_accrual')
            : (this.employeeVacationPayMethod = this.employee.vacationPayMethod);
    }
}
